import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IBookkeepingConfig {
  companyProfile?: {
    done: boolean;
    count?: number;
  };
}
export interface IFrontOfficeConfig {}
export interface IPointOfSaleConfig {}
export interface IUsersManagementConfig {}
export interface IHousekeepingConfig {}
export interface IHumanResourcesConfig {}
export interface IMaintenanceConfig {}
export interface ISalesConfig {}

export interface IInitialSetupState {
  bookkeeping: IBookkeepingConfig;
  frontOffice: IFrontOfficeConfig;
  pointOfSale: IPointOfSaleConfig;
  usersManagement: IUsersManagementConfig;
  housekeeping: IHousekeepingConfig;
  humanResources: IHumanResourcesConfig;
  maintenanceAndEngineering: IMaintenanceConfig;
  salesAndBanquet: ISalesConfig;
}

const initialState: IInitialSetupState = {
  bookkeeping: {
    companyProfile: {
      done: false,
    },
  },
  frontOffice: {},
  housekeeping: {},
  humanResources: {},
  maintenanceAndEngineering: {},
  pointOfSale: {},
  salesAndBanquet: {},
  usersManagement: {},
};

export const InitialSetupSlice = createSlice({
  name: 'initialSetup',
  initialState: initialState,
  reducers: {
    setSetupConfig: <T extends keyof IInitialSetupState>(
      state,
      action: PayloadAction<{
        module: T;
        config: IInitialSetupState[T];
      }>,
    ) => {
      // state[action.payload.module] = action.payload.config;
      state[action.payload.module] = {
        ...state[action.payload.module],
        ...action.payload.config,
      };
    },
    resetSetupConfig: <T extends keyof IInitialSetupState>(
      state,
      action: PayloadAction<T>,
    ) => {
      state[action.payload] = initialState[action.payload];
    },
  },
});

export default InitialSetupSlice.reducer;

export const { setSetupConfig, resetSetupConfig } = InitialSetupSlice.actions;
